import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { mainTheme } from 'themes';

const MainRoute: React.FC<RouteProps> = (props) => {
  return (
    <ThemeProvider theme={mainTheme}>
      <Route {...props} />
    </ThemeProvider>
  );
};

export default MainRoute;